import { render } from "./BanksTable.vue?vue&type=template&id=70db32f2"
import script from "./BanksTable.vue?vue&type=script&lang=js"
export * from "./BanksTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__